// @flow

import moment from 'moment';
import { ICONS } from 'Components/utils/icon/icons';
import { isJoyview, isTour } from 'Components/utils/product/product.utils';
import { t } from 'Src/i18n';

export function getIcons({
  price,
  type,
}: {
  price: null | ProductPrice,
  type: string,
}): Array<IconName> {
  const hasTransport = price?.termsAndConditions.departureCity?.value;
  if (isJoyview(type) || isTour(type)) return [];

  const icons = [ICONS.ACCOMODATIONS, ICONS.BAR, ICONS.DISHES];

  return [hasTransport ? ICONS.TRANSPORT : ICONS.NO_TRANSPORT, ...icons];
}

export function getInfos({
  price,
  tourDuration,
  type,
}: {
  price: null | ProductPrice,
  tourDuration?: null | string,
  type: string,
}): Array<*> {
  const infos = [];

  // departureDate
  if (!isTour(type)) {
    const departureDate = moment(price?.termsAndConditions.departureDate, 'YYYYMMDD').format(
      t('resort.startingPrice.dateFormat'),
    );

    const departureDateLabel = t('resort.startingPrice.departureDateLabel');

    infos.push(`${departureDateLabel} ${departureDate}`);

    // durationFormatted
    infos.push(price?.termsAndConditions.durationFormatted);
  }

  // duration
  if (isTour(type)) {
    infos.push(tourDuration);
  }

  // departureCity
  const departureCityLabel = t('resort.startingPrice.departureCityLabel');
  const departureCity = price?.termsAndConditions.departureCity?.name;

  if (departureCity) {
    infos.push(`${departureCityLabel} ${departureCity}`);
  }

  // accommodation
  infos.push(price?.termsAndConditions.accommodationComfortLabel);

  return infos.filter(info => info);
}

export function getLabel({ type }: { type: string }): string {
  if (isTour(type)) return '';
  return isJoyview(type)
    ? t('resort.startingPrice.roomOnly')
    : t('resort.startingPrice.allInclusive');
}
